import {Component, inject} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {FooterComponent} from "../../../common/footer/footer.component";

@Component({
  selector: 'app-imprint',
  imports: [
    AdditionalActionHeaderComponent,
    FooterComponent,
  ],
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.css'
})
export class ImprintComponent {
  locale = inject(LocaleService);
}
